<template>
  <div class="card">
    <card-m
      title="资料详情进度"
      cardWidth="100%"
      cardHeight="100%"
      maxHeight="100%"
      :show-export="true"
      export-file-name="资料详情进度"
      @export="handleExport"
    >
      <template slot="card-box">
        <cardTable
          tableID="designDetailProgress"
          :tableColumn="column"
          :mobileColumns="mobilecolumn"
          :tableData="tableDataWithStatus"
          :loading="false"
          :showPaging="false"
        />
      </template>
    </card-m>
  </div>
</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

export default {
  name: 'card-M',
props: {
  tableData: {
    type: Array,
    default: () => []
  }
},
  data() {
    return {
      totalCounts:0,
      column: [
        { prop: '类型', label: '类型' },
        { prop: '规定时间', label: '规定时间' },
        { prop: '操作时间', label: '操作时间' },
        { prop: '完成进度', label: '完成进度' },
        // 新增：超期天数（紧跟在完成进度列后面）
        { prop: '超期天数', label: '超期天数' },
        { prop: '状态', label: '状态', width: 50, custom: true, column: { type: 'icon', icon: { default: 'status-circle' }, tooltipField: '状态详情' } }
      ],
      mobilecolumn: ['类型', '规定时间', '完成进度'],
      loading:false,
    };
  },

  computed: {
    /** ✅ 计算每行状态码：0→红(超期)、1→绿(已完成)、空→灰(未开始) */
    tableDataWithStatus() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return this.tableData.map(row => {
        const deadline = row.规定时间;
        const operateTime = row.操作时间;
        const hasDeadline = deadline && deadline !== '';
        const hasOperate = operateTime && operateTime !== '';

        let statusCode = '';
        let statusDetail = '未开始';
        if (hasOperate) {
          statusCode = 1;
          statusDetail = '已完成';
        } else if (hasDeadline && new Date(deadline) < today) {
          statusCode = 0;
          statusDetail = '超期';
        }

        // 完成进度展示成百分比（1 → 100%）
        return {
          ...row,
          完成进度: this.formatPercent(row.完成进度),
          状态: statusCode,
          状态详情: statusDetail
        };
      });
    }
  },

  methods: {
    /** 完成进度 → 百分比文本：1 → 100%、0.35 → 35%；空值 → ''；非数值文案（如"已完成"）原样返回 */
    formatPercent(val) {
      if (val === '' || val == null) return '';
      const n = Number(String(val).replace('%', '').trim());
      if (isNaN(n)) return String(val);
      return Math.round(n <= 1 ? n * 100 : n) + '%';
    },
    handleExport() {
      const el = document.querySelector('#designDetailProgress');
      if (!el) return;
      const wb = XLSX.utils.table_to_book(el, { raw: true });
      const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '资料详情进度.xlsx');
      } catch (e) { /* ignore */ }
    }
  }
};
</script>

<style scoped lang="scss">
.card{
  width: 100%;
  height: 100%;
}
</style>
